<template>
  <div class="bto-sb-widget bto-sb-widget-category-nav bto-sb-widget-outrights-tabs">
    <div class="bto-sb-widget-content">
      <ul>
        <li
          v-for="(tab) in tabs"
          :key="tab.id"
          :class="{
            'bto-sb-category-nav-active': value === tab.id,
            'bto-sb-category-nav-flag': tab.class !== undefined,
          }">
          <a href="javascript:void(0);" @click="selectTab(tab.id)">
            {{ tab.tournamentName }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { EVENT_BUS } from '@bto-services/event-bus';
  export default {
    name: 'CategoryOutrightsNavComponent',
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      value: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      selectTab(tournamentId) {
        if (tournamentId === this.value) {
          return;
        }
        this.$emit('input', tournamentId);
        EVENT_BUS.$emit('categoryTabChanged');
      },
    },
  }
</script>
